import { GetCuentasBancariasByFiltersDtoProps } from "api/DTOs/GetCuentasBancariasByFiltersDto"
import { nanoid } from "nanoid"
import { useTranslation } from "react-i18next"
import { getOptions } from "../../constants"
import BankCard from "../BankCard"

const AccountsBoard = ({
  cuentasBancarias,
  handleRedirectToDetail,
  handleOpenDeleteModal,
  handleOpenEditModal,
  handleOpenModalAutorizar,
  handleOpenRevokeAuthorizationModal,
  handleRefreshList,
  getNotificationIdCompleted,
  handleReglasConciliacion,
  handlePropuestasConciliacion,
}: {
  cuentasBancarias: GetCuentasBancariasByFiltersDtoProps[] | null | undefined
  handleRedirectToDetail: (bank: GetCuentasBancariasByFiltersDtoProps) => void
  handleOpenDeleteModal: (id?: string) => void
  handleOpenEditModal: (bank: GetCuentasBancariasByFiltersDtoProps) => void
  handleOpenModalAutorizar: (bank: GetCuentasBancariasByFiltersDtoProps) => void
  handleOpenRevokeAuthorizationModal: (id?: string) => void
  handleRefreshList: (bank: GetCuentasBancariasByFiltersDtoProps) => void
  getNotificationIdCompleted: (id: string) => boolean
  handleReglasConciliacion: (iban: string) => void
  handlePropuestasConciliacion: (id: string) => void
}) => {
  const { t } = useTranslation()
  return (
    <div className='tw-bg-neutral-10 tw-grid tw-grid-cols-auto-355 tw-gap-4 tw-h-fit tw-overflow-auto tw-p-4'>
      {cuentasBancarias?.map((bank: GetCuentasBancariasByFiltersDtoProps) => (
        <BankCard
          key={nanoid()}
          data={bank}
          onClick={handleRedirectToDetail}
          handleOpenModalAutorizar={handleOpenModalAutorizar}
          menuItems={getOptions(
            handleOpenDeleteModal,
            handleOpenEditModal,
            handleOpenRevokeAuthorizationModal,
            handleRefreshList,
            getNotificationIdCompleted,
            handleReglasConciliacion,
            handlePropuestasConciliacion,
            !bank.necesitaValidacion,
            bank,
            t
          )}
        />
      ))}
    </div>
  )
}

export default AccountsBoard
